import { AdminOrderItemComponent } from './admin-order-item-component';

export class AdminOrderItemComponentGroup {
  public constructor(
    private readonly data: {
      name: string;
      isRandomSelected: boolean;
      components: AdminOrderItemComponent[];
    },
  ) {}

  public get name(): string {
    return this.data.name;
  }

  public get isRandomSelected(): boolean {
    return this.data.isRandomSelected;
  }

  public get components(): AdminOrderItemComponent[] {
    return this.data.components;
  }
}
